module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"gatsby-supermakler","short_name":"supermakler","start_url":"/","icon":"src/resources/favicon/ikona-supermakler.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"f4cfdde0be4444a8abb85edccc825dc8"},
    }]
